module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/Seafood.0806921a.svg";